const projectsData = [
  {
    id: "jobai",
    title: "JobAI : AI-Powered Career Guide",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20(7).png?alt=media",
    deployedLink: "https://job-ai-5ojy.vercel.app/",
    githubLink: "https://github.com/ayush123-bit/JobAI",
    youtubeLink: "https://www.loom.com/share/556fa512e4a042e0937e34d553109156",
    category: "AI-Powered Full Stack Project",
    priority: 1,
  },
  {
    id: "ai-event-organiser",
    title: "AI Event Organiser",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-12-23%20021431.png?alt=media",
    deployedLink: "https://ai-event-organiser-ten.vercel.app/",
    githubLink: "https://github.com/ayush123-bit/AI-Event-Organiser",
    youtubeLink: "",
    category: "AI Full Stack Development",
    priority: 1,
  },
  {
    id: "rescuesalary",
    title: "RescueSalary : AI-Powered Account Management",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20(5).png?alt=media",
    deployedLink: "https://rescue-salary-9uku.vercel.app/",
    githubLink: "https://github.com/ayush123-bit/RescueSalary",
    youtubeLink: "https://youtu.be/0lBkD7syaKQ",
    category: "AI-Powered Full Stack Project",
    priority: 2,
  },
  {
    id: "kaamwale",
    title: "KaamWale : Job Portal Website",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-07-28%20164320.png?alt=media",
    deployedLink: "https://scintillating-kelpie-de0c3d.netlify.app/",
    githubLink: "https://github.com/ayush123-bit/KaamWale",
    youtubeLink: "https://www.loom.com/share/76a9a8b9d6cd4b68801a80d84060bd21",
    category: "Full Stack Development",
    priority: 3,
  },
  {
    id: "shopeasy",
    title: "ShopEasy",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20(76).png?alt=media",
    deployedLink: "https://dapper-chaja-9ec520.netlify.app/",
    githubLink: "https://github.com/ayush123-bit/MallBack",
    youtubeLink: "https://youtu.be/c5nPyUx4Y0A",
    category: "Full Stack Web Development",
    priority: 4,
  },
  {
    id: "product-data-management",
    title: "Product Data Management",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20(79).png?alt=media",
    deployedLink: "https://singular-pony-9e4314.netlify.app/",
    githubLink: "https://github.com/ayush123-bit/ManageProduct",
    youtubeLink: "https://youtu.be/ev9RYdct7Vo",
    category: "Full Stack Web Development",
    priority: 5,
  },
  {
    id: "slotify",
    title: "Slotify: AI-powered Google Calendar Scheduler",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-06-28%20233825.png?alt=media",
    deployedLink: "https://slotify-rcnrhks6szilfcrbpdwnu9.streamlit.app/",
    githubLink: "https://github.com/ayush123-bit/Slotify",
    youtubeLink: "",
    category: "Natural Language Processing",
    priority: 6,
  },
  {
    id: "ai-meeting-notes",
    title: "AI Meeting Notes Summariser",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-09-01%20104310.png?alt=media",
    deployedLink: "https://mongo-desk-frontend.vercel.app/",
    githubLink: "https://github.com/ayush123-bit/MongoDesk",
    youtubeLink: "https://www.loom.com/share/e94173a019384da68d9147ecad245927",
    category: "Project",
    priority: 6,
  },
  {
    id: "notes-app",
    title: "Full Stack Notes Taking Application",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-09-01%20105406.png?alt=media",
    deployedLink: "https://highwaydelite3108.netlify.app",
    githubLink: "https://github.com/ayush123-bit/Notes-App",
    youtubeLink: "https://www.loom.com/share/52d6587be0794587a66b52624bf0057d",
    category: "Project",
    priority: 6,
  },
  {
    id: "emotion-analyser",
    title: "Emotion Analyser",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-07-25%20013422.png?alt=media",
    deployedLink: "https://prismatic-torrone-587cf4.netlify.app/",
    githubLink: "https://github.com/ayush123-bit/Emotion-Analyser",
    youtubeLink: "https://www.loom.com/share/08e709df7c614950a04c813fdc327d12",
    category: "Full Stack Web Development (LLM)",
    priority: 7,
  },
  {
    id: "batcheet",
    title: "BatCheet",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(155).png?alt=media",
    deployedLink: "https://clinquant-cupcake-e24d24.netlify.app/",
    githubLink: "https://github.com/ayush123-bit/BatCheet",
    youtubeLink: "",
    category: "Full Stack Web Development",
    priority: 7,
  },
  {
    id: "mini-ecommerce",
    title: "Mini Ecommerce Website",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-09-07%20120246.png?alt=media",
    deployedLink: "https://fastidious-pasca-b2c0e7.netlify.app/",
    githubLink: "https://github.com/ayush123-bit/Astrape",
    youtubeLink: "",
    category: "Web Development",
    priority: 7,
  },
  {
    id: "xml-parser",
    title: "XML Parser",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-10-18%20000221.png?alt=media",
    deployedLink: "https://musical-rabanadas-ba6d4c.netlify.app/upload",
    githubLink: "https://github.com/ayush123-bit/CreditSea",
    youtubeLink: "https://www.loom.com/share/22fb1460738e406684f0d1bdab426e21",
    category: "Full Stack Development",
    priority: 7,
  },
  {
    id: "livesitter",
    title: "Livesitter",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-10-18%20001130.png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/Livesitter",
    youtubeLink: "https://www.loom.com/share/0b3f1e0bf9c74d709cdf846cbab2043f",
    category: "Python Development",
    priority: 7,
  },
  {
    id: "ai-object-detection",
    title: "AI Object Detection",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%202025-02-16%20170723.png?alt=media",
    deployedLink: "https://ai-object-detection-gules.vercel.app/",
    githubLink: "https://github.com/ayush123-bit/AI-Object-Detection",
    youtubeLink: "",
    category: "AI-Powered Full Stack Project",
    priority: 8,
  },
  {
    id: "translater",
    title: "TransLater : AI-Powered Language Translator",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(38).png?alt=media",
    deployedLink: "https://trans-later-q11i.vercel.app/",
    githubLink: "https://github.com/ayush123-bit/TransLater",
    youtubeLink: "",
    category: "AI-Powered Full Stack Project",
    priority: 9,
  },
  {
    id: "grievance-cell",
    title: "Grievance Cell : College Complaint Website",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-07-28%20192145.png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/Grievance-Cell",
    youtubeLink: "https://youtu.be/dPA9MsBMBrg",
    category: "Full Stack Development",
    priority: 10,
  },
  {
    id: "waste-management",
    title: "Waste Management Project",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20(11).png?alt=media",
    deployedLink: "",
    githubLink: "",
    youtubeLink: "https://youtu.be/os8GzKOJ6oE",
    category: "Full Stack Web Development",
    priority: 11,
  },
  {
    id: "spam-detection",
    title: "Spam Detection Project",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20%283%29.png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/SpamWebsite",
    youtubeLink: "https://youtu.be/g3W8Yew82mE",
    category: "Machine Learning",
    priority: 12,
  },
  {
    id: "url-hashing",
    title: "Url Hashing",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%20(77).png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/HashUrl",
    youtubeLink: "https://youtu.be/exMLHRJ_Q4Q",
    category: "Full Stack Web Development",
    priority: 13,
  },
  {
    id: "daily-news",
    title: "Daily News App",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FReact%20App%20-%20Google%20Chrome%2001-11-2024%2010_11_44.png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/DailyNews",
    youtubeLink: "https://youtu.be/VhqUXDTAn_8",
    category: "Full Stack Web Development",
    priority: 14,
  },
  {
    id: "search-smart",
    title: "Search Smart",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%202024-11-02%20231906.png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/SmartSearch",
    youtubeLink: "https://youtu.be/nyR1vCfJZ1w",
    category: "Full Stack Web Development",
    priority: 16,
  },
  {
    id: "diabetes-prediction",
    title: "Diabetes Prediction",
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/projects%2FScreenshot%202024-11-03%20001626.png?alt=media",
    deployedLink: "",
    githubLink: "https://github.com/ayush123-bit/DiabetesPredictor",
    youtubeLink: "",
    category: "Machine Learning",
    priority: 17,
  },
];

export default projectsData;